import { OrientationAxis } from '../../../enums';
import { clonePlanarOrientation } from './planarLegacyCompatibility';
export { DEFAULT_PLANAR_CPU_IMAGE_THRESHOLD, DEFAULT_PLANAR_CPU_VOLUME_THRESHOLD, PlanarRenderPathDecisionService, defaultPlanarRenderPathDecisionService, getPlanarAcquisitionOrientation, selectPlanarRenderPath, shouldUseCPU, } from './PlanarRenderPathDecisionService';
export function normalizePlanarOrientation(orientation, acquisitionOrientation) {
    if (!orientation || orientation === OrientationAxis.ACQUISITION) {
        return OrientationAxis.ACQUISITION;
    }
    if (acquisitionOrientation && orientation === acquisitionOrientation) {
        return OrientationAxis.ACQUISITION;
    }
    return clonePlanarOrientation(orientation);
}
